import { memo } from 'react'

import { AiSkeletonItemWrapper } from './styled'
import LoadingSkeleton from 'common-components/LoadingSkeleton'

const AiSkeletonItem = ({
  width,
  height,
  className,
  aspectRatio
}: {
  width?: string
  height?: string
  className?: string
  aspectRatio?: string
}) => {
  return (
    <AiSkeletonItemWrapper
      width={width}
      height={height}
      className={className}
      $aspectRatio={aspectRatio}
    >
      <LoadingSkeleton />
    </AiSkeletonItemWrapper>
  )
}

export default memo(AiSkeletonItem)
